/* TurboTubes — looping brand-values cycler (editable, infinite) */
(function () {
  "use strict";

  function boot() {
    var root = document.querySelector(".vcycle");
    if (!root) return;

    var HOLD = parseInt(root.getAttribute("data-hold"), 10) || 2800;
    var EXIT = parseInt(root.getAttribute("data-exit"), 10) || 700;

    var VALUES = [
      { pre: "We deliver ", hl: "quality", post: ".", sub: "We settle only for the very best material — and test every tube to its limit." },
      { pre: "We are ", hl: "reliable", post: ".", sub: "A deal is a deal. You can trust our products and our promises completely." },
      { pre: "", hl: "Passion", post: " drives us.", sub: "We're on the track ourselves, and that love for the sport shows in everything we do." }
    ];
    var src = document.querySelector("[data-tt-values]");
    if (src) {
      try {
        var parsed = JSON.parse(src.textContent);
        if (parsed && parsed.length) VALUES = parsed;
      } catch (e) {}
    }

    var elNum = root.querySelector(".vcycle-num");
    var elTitle = root.querySelector(".vcycle-title");
    var elSub = root.querySelector(".vcycle-sub");
    var dotsWrap = document.querySelector(".vcycle-dots");

    var dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = "";
      for (var d = 0; d < VALUES.length; d++) {
        var dot = document.createElement("i");
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
    }

    var i = 0, timer = null, paused = false;

    function esc(str) {
      return String(str == null ? "" : str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    function paint(idx) {
      var v = VALUES[idx];
      elNum.textContent = String(idx + 1).padStart(2, "0");
      elTitle.innerHTML = esc(v.pre) + '<span class="hl">' + esc(v.hl) + "</span>" + esc(v.post);
      elSub.textContent = v.sub;
      dots.forEach(function (dt, k) { dt.classList.toggle("on", k === idx); });
    }
    function enter() {
      if (paused) { timer = setTimeout(enter, 300); return; }
      paint(i);
      root.classList.remove("out");
      void root.offsetWidth;
      root.classList.add("in");
      timer = setTimeout(exit, HOLD);
    }
    function exit() {
      root.classList.remove("in");
      root.classList.add("out");
      timer = setTimeout(function () { i = (i + 1) % VALUES.length; enter(); }, EXIT);
    }

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) { paused = !entries[0].isIntersecting; }, { threshold: 0.15 });
      io.observe(root);
    }

    paint(0);
    setTimeout(enter, 200);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
